'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'OperationTypeService',
                function($scope, $routeParams, $window,  OperationTypeService) {
                    $scope.types = [];
                    OperationTypeService.api.get({
                                           filters: [`'status' EQ 'ENABLED'`],
                                           sorts: ['name:ASC'],
                                       }, (data) => $scope.types = data._embedded);
                }];
